class AccordionInfo extends HTMLElement {
  constructor() {
    super();
    this._handleAccordionToggle = this._handleAccordionToggle.bind(this);
  }

  connectedCallback() {
    this.container = this.querySelector('#productDescription');
    this.accordions = this.querySelectorAll('.faq__accordion .shared-accordion__wrapper');

    this._styleLinks();
    this._setupAccordionHandlers();
    this._openDefaultAccordion();
  }

  _styleLinks() {
    if (!this.container) return;

    const links = this.container.querySelectorAll('a');
    links.forEach((link) => {
      const text = link.textContent;

      link.className = 'shared-link__link fixed-utility-s shared-link--small shared-link--underline';

      const labelSpan = document.createElement('span');
      labelSpan.className = 'shared-link__label';

      const innerSpan = document.createElement('span');
      innerSpan.className = 'shared-link__label--first fixed-utility-s-em';
      innerSpan.textContent = text;

      link.textContent = '';
      labelSpan.appendChild(innerSpan);
      link.appendChild(labelSpan);
    });
  }

  _setupAccordionHandlers() {
    this.accordions.forEach((accordion) => {
      accordion.addEventListener('click', this._handleAccordionToggle);
      accordion.addEventListener('keydown', this._handleAccordionToggle);
    });
  }

  _handleAccordionToggle(e) {
    const accordion = e.currentTarget.closest('.shared-accordion__wrapper');
    const isKeyboard = e.type === 'keydown';

    if (isKeyboard && e.key !== 'Enter' && e.key !== ' ') return;

    this._closeOtherAccordions(accordion);

    if (isKeyboard) {
      e.preventDefault();
      if (e.key === ' ') {
        accordion.toggleAttribute('open');
      }
    }

    requestAnimationFrame(() => {
      const isOpen = accordion.hasAttribute('open');
      accordion.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  _closeOtherAccordions(currentAccordion) {
    this.accordions.forEach((accordion) => {
      if (accordion !== currentAccordion && accordion.hasAttribute('open')) {
        accordion.removeAttribute('open');
        accordion.setAttribute('aria-expanded', 'false');
      }
    });
  }

  _openDefaultAccordion() {
    const highlightsAccordion = this.querySelector('.faq__accordion.accordion__highlight');
    const productDetailsAccordion = this.querySelector(
      '.faq__accordion.product-details-accordion > .shared-accordion__wrapper'
    );

    if (highlightsAccordion) {
      highlightsAccordion.setAttribute('open', '');
      highlightsAccordion.setAttribute('aria-expanded', 'true');
    } else if (productDetailsAccordion) {
      productDetailsAccordion.setAttribute('open', '');
      productDetailsAccordion.setAttribute('aria-expanded', 'true');
    }
  }
}

customElements.define('product-accordions', AccordionInfo);
